const getValue = (value, key) => value?.[key] ?? value?.[`${key[0].toUpperCase()}${key.slice(1)}`];

const normalizeStatusKey = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("vi-VN")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\u0111/g, "d");

export const isPendingApprovalStatus = (value) => {
  const status = normalizeStatusKey(value);
  return (status.includes("cho") && status.includes("duyet")) || status.includes("dang xu ly");
};

export const getCurrentApprovalStep = (profile) => {
  const steps = getValue(profile, "steps");
  if (!Array.isArray(steps)) return null;

  const currentStepOrder = Number(getValue(profile, "currentStepOrder"));
  return steps.find((step) => Number(getValue(step, "stepOrder")) === currentStepOrder)
    || steps.find((step) => normalizeStatusKey(getValue(step, "status")).includes("dang xu ly"))
    || null;
};

export const isCurrentUserApprover = (profile, userId) => {
  if (!profile || !isPendingApprovalStatus(getValue(profile, "status"))) return false;

  const normalizedUserId = Number(userId);
  if (!Number.isFinite(normalizedUserId) || normalizedUserId <= 0) return false;

  const currentStep = getCurrentApprovalStep(profile);
  const approverUserId = Number(
    getValue(currentStep, "approverUserId") ?? getValue(profile, "approverUserId"),
  );
  return approverUserId === normalizedUserId;
};

export const isApprovedStatus = (value) => {
  const status = normalizeStatusKey(value);
  return status.includes("da phe duyet") || status.includes("duoc phe duyet");
};

const getProfileTimestamp = (profile) =>
  new Date(profile?.submittedAt ?? profile?.SubmittedAt ?? profile?.createdAt ?? profile?.CreatedAt ?? 0).getTime();

const getSubmitCount = (profile) => Number(getValue(profile, "submitCount") || 0);

export const compareApprovalProfiles = (left, right) => {
  const submitCountDiff = getSubmitCount(right) - getSubmitCount(left);
  if (submitCountDiff) return submitCountDiff;
  return getProfileTimestamp(right) - getProfileTimestamp(left);
};

export const getLatestApprovalProfile = (profiles = []) =>
  [...profiles].sort(compareApprovalProfiles)[0] || null;
